// removed by extract-text-webpack-plugin
module.exports = {"top":"align__top___23GkX verticalAlign-top","middle":"align__middle___36vRU verticalAlign-middle","bottom":"align__bottom___lPiYq verticalAlign-bottom"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/InlineGrid/style/align.css
// module id = 11
// module chunks = 0 1 2 3 6